import TableList from "@components/templates/tablelist";
import { HttpAllotList, HttpUpdateAllotStatus, HttpCancelAllot,HttpSubmitAllot,HttpSureAllot, HttpConfirmAllot, HttpAddressCodeList } from "@/service/allotment/allots";;
import { mapState, mapGetters } from "vuex";
import compBoxingdetail from './serviceallot/boxingdetail'
import comUpdate from './serviceallot/update'
export default {
    mixins: [TableList],
    components: {
        compBoxingdetail,
        comUpdate
    },
    data() {
        return {
            isMixin: true,
            formData: {
                srcLabel: 0
            },
            Header: {
                show: true,
            },
            Tools: {
                show: true,
                data: [
                    {
                        name: "添加",
                        operate: "add",
                        theme: "primary"
                    },
                    {
                        name: "批量导入",
                        operate: "upload",
                        theme: "info"
                    },
                    {
                        name: "批量提交",
                        operate: "batchSubmit",
                        more: true,
                        batch: true
                    },
                    {
                        name: "批量确认",
                        operate: "confirm",
                        more: true,
                        batch: true
                    },
                    {
                        name: "批量取消",
                        operate: "batchcancel",
                        more: true,
                        batch: true
                    },
                    {
                        name: "批量导出",
                        operate: "download",
                        more: true,
                        batch: true
                    }
                ]
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {
                show: true
            },
            routename:this.$route.name
        };
    },
    methods: {
        ajaxRequest: HttpAllotList,
        // toolsRender(){
        //     return <div style="background:#fff">123123123</div>
        // },
        handleOperates(params = "", type, batch) {
            this.operate = {};
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            // const routesMap={
            //     "-1":['onsiteAllotUpdate','onsiteAllotBoxing'],
            //     0:['serviceAllotUpdate','serviceAllotBoxing'],
            //     1:['otherAllotUpdate','otherAllotBoxing'],
            //     2:['procureAllotUpdate','procureAllotBoxing'],
            //     3:['amazonAllotUpdate','amazonAllotBoxing'],
            // },
            const transferType = this.formData.srcLabel,
                // [routeUpdate,routeBoxing]=routesMap[transferType]||routesMap[0];
                routeUpdate = this.$route.name + "Update", routeBoxing = this.$route.name + "Boxing";

            switch (type) {
                case "add":
                    this.$router.push({
                        name: routeUpdate,
                        params: { type: "add" },
                        query: { transferType },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: routeUpdate,
                        params: { type: "edit" },
                        query: { id: params, transferType },
                    });
                    break;
                case "query":
                    this.operate = {
                        show:true,
                        width:1200,
                        title:'查看',
                        component: "comUpdate",
                        activeids:params,
                        transType:transferType,
                        querytype:'query',
                        showFooter:false
                    }
                    // var url = this.$router.resolve({
                    //     name: routeUpdate,
                    //     params: { type: "query" },
                    //     query: { id: params, transferType },
                    // });
                    // window.open(url.href, '_blank');
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: routeUpdate,
                        params: { type: "query" },
                        query: { id: params, transferType },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "editbox":
                    this.$router.push({
                        name: routeBoxing,
                        query: { ...params, transferType },
                    });
                    break;
                case "querybox":
                    this.$VModal.default({
                        title: "装箱信息",
                        width: 1000,
                        showFooter: false,
                        render: (h, props) => {
                            return this.$createElement('compBoxingdetail', { props: params })
                        }
                    });
                    break;
                case "submit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: {
                            id: params,
                            status: 210
                        },
                        title: "提交",
                        desc: "提交后将由商舟仓储人员审核，预计3-7个工作日可查看审核结果。注意：审核通过后不可更改单据信息，如有问题可联系商舟客服。确认提交？",
                        ajaxRequest: HttpUpdateAllotStatus,
                    };
                    break;
                    case "sure":
                        this.operate = {
                            show: true,
                            alert: "info",
                            width: 460,
                            showDesc: false,
                            params: {
                                id: params
                            },
                            title: "确认",
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: "备注",
                                    labelWidth: 'auto',
                                    required: false,
                                }
                            ],
                            ajaxRequest: HttpSureAllot,
                        };
                        break;
                case "confirm":
                    this.operate = {
                        show: true,
                        alert: "info",
                        params: {
                            ids: params,
                        },
                        title: "批量确认",
                        desc: "确认操作？",
                        ajaxRequest: HttpConfirmAllot,
                    };
                    break;
                case "batchSubmit":
                        this.operate = {
                            show: true,
                            alert: "info",
                            params: {
                                ids: params,
                            },
                            title: "批量提交",
                            desc: "确认提交？",
                            ajaxRequest: HttpSubmitAllot,
                        };
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: {
                            id: params,
                            status: 300,
                        },
                        title: "删除",
                        desc: "确认删除？",
                        ajaxRequest: HttpUpdateAllotStatus
                    };
                    break;
                case "cancel":
                    this.operate = {
                        title: "取消",
                        alert: "warning",
                        width: 500,
                        show: true,
                        width: 460,
                        params: {
                            status: 400,
                            id: params
                        },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "cancelCause",
                                span: 24,
                                label: "取消原因"
                            }
                        ],
                        ajaxRequest: HttpUpdateAllotStatus,
                    };
                    break;
                case "batchcancel":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: {
                            ids: params
                        },
                        title: "取消",
                        ajaxRequest: HttpCancelAllot
                    };
                    break;
                case 'upload':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width: 460,
                        data: {
                            node: transferType,
                        },
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/importTransfer",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/Transfer/transferTemplate', { node: transferType }, 'download')
                        },
                    };
                    break;
                case 'downloadurl': this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/Transfer/downloadBoxLabel', { transferOutboundPlanId: params }, 'download');
                    break;
                case 'download': {
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/Transfer/exportTransferListByIds', { srcLabel: transferType, idsStr: params }, 'download');
                };
                    break;
            }
        },
    },
    computed: {
        // ...mapState('boss', ['accounts', 'products', 'warehouseList']),
        ...mapGetters('dictionary', ['getFilterDisabledAllWarehouse']),
        ...mapGetters('dictionary',['getFilterDisabledAllWarehouse']),
        ...mapGetters('diction',['getNewWarehouseCodeList','getNewDifferentAllProductList']),
        orderStatus() {
            return [
                {
                    value: 0,
                    label: '草稿',
                    theme: 'info',
                },
                {
                    value: 3,
                    label: '已驳回',
                    theme: 'error',
                },
                {
                    value: 5,
                    label: '待审核',
                    theme: 'warning'
                },
                {
                    label: "审核中",
                    value: 6,
                    theme: 'warning'
                },
                {
                    label: "待确认",
                    value: 8,
                    theme: 'success'
                },
                {
                    value: 10,
                    label: '待出库',
                    theme: 'primary'
                },
                {
                    value: 15,
                    label: '出库中',
                    theme: 'warning',
                },
                {
                    value: 20,
                    label: '已出库',
                    theme: 'primary'
                },
                {
                    value: 25,
                    label: '入库中',
                    theme: 'warning',
                },
                {
                    value: 70,
                    label: '已完成',
                    theme: 'success',
                },
               /*  {
                    value: 90,
                    label: '已取消',
                    theme: 'default',
                }, */
               /*  {
                    label: "取消中",
                    value: 100,
                }, */
                {
                    label: "已取消",
                    value: 110,
                    theme: 'error'
                },
                {
                    label: "取消异常",
                    value: 120,
                    theme: 'error'
                }
            ];
        },
        SearchsData() {
            const srcLabel = this.formData.srcLabel,
                // warehouses = this.warehouseList.map((item) => {
                //     const { code, title } = item,
                //         label = title ? `${title}(${code})` : code;
                //     return {
                //         value: code,
                //         label
                //     }
                // }),
                getFilterDisabledAllWarehouse = this.getFilterDisabledAllWarehouse.map((item) => {
                    // console.log(item)
                    const { attach,label } = item
                    return {
                        value: attach.code,
                        label
                    }
                }),
                dropStyle = "width:auto;min-width:186px;";
            const data = [
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    props: {
                        dropStyle,
                        filterable: true,
                    },
                    options: this.getNewDifferentAllProductList,
                    show: true,
                },
                {
                    label: "调拨计划单号",
                    tag: 'vInput',
                    key: 'EQ_transferOutboundPlanNo',
                    show: true,
                },
                {
                    label: "内部识别号",
                    tag: 'vInput',
                    key: 'EQ_internalDiscernNo',
                    show: true,
                },
                {
                    label: "ERP SKU",
                    tag: 'vInput',
                    key: 'EQ_transferOutboundPlanItemList.sku',
                },
                {
                    label: "单据状态",
                    tag: 'vSelect',
                    key: 'IN_transferOutboundPlanStatus',
                    hideSearchTip: true,
                    formatter(value) {
                        return (value || []).join(',')
                    },
                    style: "width:362px",
                    props: {
                        multiple: true,
                        dropStyle
                    },
                    options: this.orderStatus,
                },
                {
                    label: "调出仓库",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    props: {
                        dropStyle,
                        filterable: true,
                    },
                    options: getFilterDisabledAllWarehouse,
                    hidden:this.routename !== 'onsiteAllot'
                },
                {
                    label: "调入仓库",
                    tag: 'vSelect',
                    key: srcLabel != 2 ? 'EQ_inOrgWarehouseCode' : 'EQ_sourceChannel',
                    props: {
                        dropStyle,
                        filterable: true,
                    },
                    has: srcLabel != 2,
                    options: getFilterDisabledAllWarehouse,
                    hidden:this.routename !== 'onsiteAllot'
                },
                {
                    label: "调出仓库",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    props: {
                        dropStyle,
                        filterable: true,
                    },
                    options: this.getNewWarehouseCodeList,
                    hidden:this.routename === 'onsiteAllot'
                },
                {
                    label: "调入仓库",
                    tag: 'vSelect',
                    key: srcLabel != 2 ? 'EQ_inOrgWarehouseCode' : 'EQ_sourceChannel',
                    props: {
                        dropStyle,
                        filterable: true,
                    },
                    has: srcLabel != 2,
                    options: this.getNewWarehouseCodeList,
                    hidden:this.routename === 'onsiteAllot'
                },
                {
                    label: "目的地址代码",
                    tag: 'vSelect',
                    key: 'EQ_receiveStore',
                    props: {
                        dropStyle
                    },
                    has: srcLabel == 1,
                    methods: {
                        getCodeList() {
                            HttpAddressCodeList({
                                page: 1,
                                rows: 200,
                                sidx: 'id',
                                sord: 'desc',
                                search: {
                                    NE_warehouseType: 2
                                }
                            }).then(res => {
                                const data = res.data.content.map(item => {
                                    return item.code
                                })
                                this.$set(this.baseData, 'codeList', data)
                            })
                        }
                    },
                    created() {
                        this.getCodeList();
                    },
                    children() {
                        return (this.baseData.codeList || []).map(function (item) {
                            return <vOption value={item}>{item}</vOption>
                        })
                    },
                },
                {
                    label: "调拨类型",
                    tag: 'vSelect',
                    key: 'EQ_isOnsite',
                    has: srcLabel == 0 || srcLabel == 1,
                    options: [
                        {
                            value: 0,
                            label: '普通 '
                        },
                        {
                            value: 1,
                            label: 'onsite'
                        }
                    ]
                },
                {
                    label: "库存类型",
                    tag: 'vSelect',
                    key: 'EQ_inventoryType',
                    options: [
                        {
                            value: 0,
                            label: '可售库存'
                        },
                        {
                            value: 1,
                            label: '不可售库存'
                        }
                    ]
                },
                {
                    label: "是否换标",
                    tag: 'vSelect',
                    key: 'EQ_isLabel',
                    options: [
                        {
                            value: 1,
                            label: '是'
                        },
                        {
                            value: 0,
                            label: '否'
                        }
                    ]
                },

                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'CN_trackingNo',
                    show: false
                },
                {
                    label: "Shipment ID",
                    tag: 'vInput',
                    key: 'EQ_shipmentId',
                    has: srcLabel == 3
                },
                {
                    label: "Reference ID",
                    tag: 'vInput',
                    key: 'EQ_removeOrderId',
                    has: srcLabel == 3
                },
            ];
            return data.filter(item => {
                const has = item.has;
                return !!(has === undefined || has);
            })
        },
        columns() {
            const srcLabel = this.formData.srcLabel;
            const data = [{
                type: 'selection',
                width: 50,
                align: 'center',
                formName: 'id'
            }, {
                title: '操作',
                width: 70,
                render: (h, { row }) => {
                    let { id, transferOutboundPlanNo, transferOutboundPlanStatus = 0, labelCreateStatus } = row;
                    return <vDropdown placement="bottom-left" trigger="click">
                        <vButton size='small' theme='info'>操作 <vIcon type="arrow-dropdown" /></vButton>
                        <template slot="list" class="text-left">
                            <vDropdownItem v-show={transferOutboundPlanStatus == 0 || transferOutboundPlanStatus == 3} nativeOnClick={this.handleOperates.bind(this, id, 'submit')}>提交</vDropdownItem>
                            <vDropdownItem v-show={transferOutboundPlanStatus == 0 || transferOutboundPlanStatus == 3} nativeOnClick={this.handleOperates.bind(this, id, 'edit')}>编辑</vDropdownItem>
                            <vDropdownItem nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看详情</vDropdownItem>
                            <vDropdownItem v-show={transferOutboundPlanStatus == 8} nativeOnClick={this.handleOperates.bind(this, id, 'sure')}>确认</vDropdownItem>
                            <vDropdownItem v-show={transferOutboundPlanStatus == 10} nativeOnClick={this.handleOperates.bind(this, { id, transferOutboundPlanNo, labelCreateStatus }, 'editbox')}>编辑装箱</vDropdownItem>
                            <vDropdownItem v-show={transferOutboundPlanStatus == 15 || transferOutboundPlanStatus == 10} nativeOnClick={this.handleOperates.bind(this, { id, transferOutboundPlanNo }, 'querybox')}>查看装箱</vDropdownItem>
                            <vDropdownItem v-show={labelCreateStatus == 20} nativeOnClick={this.handleOperates.bind(this, id, 'downloadurl')}>导出箱标</vDropdownItem>
                            <vDropdownItem v-show={transferOutboundPlanStatus == 0} nativeOnClick={this.handleOperates.bind(this, id, 'delete')}>删除</vDropdownItem>
                            <vDropdownItem v-show={transferOutboundPlanStatus == 5 || transferOutboundPlanStatus == 3} nativeOnClick={this.handleOperates.bind(this, id, 'cancel')}>取消</vDropdownItem>
                        </template>
                    </vDropdown>

                }
            }, {
                title: srcLabel == 2 ? '采购退货单号' : '调拨计划单号',
                key: 'transferOutboundPlanNo',
                render: (h, { row }) => {
                    const { id, transferOutboundPlanNo, internalDiscernNo } = row;
                    return <div>
                        {/* <a onClick={this.handleOperates.bind(this, id, 'query')}>{transferOutboundPlanNo}</a> */}
                        <a onClick={this.handleOperates.bind(this, id, 'query' )}>{transferOutboundPlanNo}</a>
                        <a onClick={this.handleOperates.bind(this, id, 'queryBlank' )}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        <div v-show={srcLabel != 3 && internalDiscernNo}>{internalDiscernNo} (识别号)</div>
                    </div>
                }
            },
            {
                title: '单据状态',
                key: 'transferOutboundPlanStatus',
                sortable: true,
                maxWidth: 100,
                render: (h, { row }) => {
                    const status = row.transferOutboundPlanStatus;
                    const { theme = "default", label } = this.orderStatus.find((item) => {
                        return item.value == status
                    }) || {};
                    return <vButton theme={theme} size="small" class="cursor-default" style="width:60px;">{label}</vButton>
                }
            },
            {
                title: '识别号',
                key: 'internalDiscernNo',
                sortable: true,
                has: srcLabel == 3,
                render: (h, { row }) => {
                    const { internalDiscernNo = "", shipmentId } = row;
                    return <div>
                        <div>识别号:{internalDiscernNo}</div>
                        <div>shipmentId:{shipmentId}</div>
                    </div>
                }
            },
            {
                title: '项目',
                key: 'lineId',
                maxWidth: 100,
                sortable: true,
                render: (h, { row }) => {
                    const id = row.lineId;
                    return (this.getNewDifferentAllProductList.find(function (item) {
                        return item.value == id;
                    }) || {}).label
                }
            },
            {
                title: '调拨信息',
                key: '-',
                sortable: true,
                render: (h, { row }) => {
                    const { orgWarehouseTitle, inOrgWarehouseTitle, sourceChannel, inventoryType, receiveStore } = row;
                    return <div>
                        <div>{orgWarehouseTitle}(出)</div>
                        {srcLabel != 2 ? (srcLabel == 1 ? <div>{sourceChannel}(渠道)<br />{receiveStore}(入)</div> : <div>{inOrgWarehouseTitle}(入)</div>) : null}
                        <div>{inventoryType == 0 ? '可售库存' : '不可售库存'}</div>
                    </div>
                }
            },
            {
                title: '创建时间',
                key: 'createdAt',
                sortable: true
            }];
            return data.filter(item => {
                const has = item.has;
                return !!(has === undefined || has);
            })
        },

    },

};